import { BuildingId, DeviceConfigId, DeviceId, Schedule, Theme, ThemeId } from 'shared/models';

export const Actions = {
    DELETE_THEME_SUCCESS: 'DELETE_THEME_SUCCESS',

    PUBLISH_THEME_REQUEST: 'PUBLISH_THEME_REQUEST',
    PUBLISH_THEME_SUCCESS: 'PUBLISH_THEME_SUCCESS',
    PUBLISH_THEME_FAILURE: 'PUBLISH_THEME_FAILURE',

    PUBLISH_THEME_STATUS_QUEUED: 'PUBLISH_THEME_STATUS_QUEUED',
    PUBLISH_THEME_STATUS_IN_PROGRESS: 'PUBLISH_THEME_STATUS_IN_PROGRESS',
    PUBLISH_THEME_STATUS_OKAY: 'PUBLISH_THEME_STATUS_OKAY',
    PUBLISH_THEME_STATUS_ERROR: 'PUBLISH_THEME_STATUS_ERROR',

    UNPUBLISH_THEME_REQUEST: 'UNPUBLISH_THEME_REQUEST',
    UNPUBLISH_THEME_SUCCESS: 'UNPUBLISH_THEME_SUCCESS',
    UNPUBLISH_THEME_FAILURE: 'UNPUBLISH_THEME_FAILURE',
    
    COPY_THEME_TO_BUILDING_SUCCESS: 'COPY_THEME_TO_BUILDING_SUCCESS',

    RESET_THEME_STATUS_REQUEST: 'RESET_THEME_STATUS_REQUEST',
    RESET_THEME_STATUS_SUCCESS: 'RESET_THEME_STATUS_SUCCESS',
    RESET_THEME_STATUS_FAILURE: 'RESET_THEME_STATUS_FAILURE',

    UPLOAD_THEME_REQUEST: 'UPLOAD_THEME_REQUEST',
    UPLOAD_THEME_PROGRESS: 'UPLOAD_THEME_PROGRESS',
    UPLOAD_THEME_SUCCESS: 'UPLOAD_THEME_SUCESS',
    UPLOAD_THEME_FAILURE: 'UPLOAD_THEME_FAILURE',
    CLEAR_UPLOAD_THEME: 'CLEAR_UPLOAD_THEME',

    SCHEDULE_THEME_SUCCESS: 'SCHEDULE_THEME_SUCCESS',
};

export const deleteThemeSuccess = (themeId: string) => ({
    type: Actions.DELETE_THEME_SUCCESS,
    payload: themeId,
});

export const publishThemeRequest = (themeId: ThemeId, meta: { buildingId: BuildingId; elevatorId?: string; deviceConfigId?: DeviceConfigId }) => ({
    type: Actions.PUBLISH_THEME_REQUEST,
    payload: themeId,
    meta,
});
export const publishThemeSuccess = (theme: Theme) => ({
    type: Actions.PUBLISH_THEME_SUCCESS,
    payload: theme,
});
export const publishThemeFailure = (err: Error) => ({
    type: Actions.PUBLISH_THEME_FAILURE,
    error: true,
    payload: err,
});

// TODO: each publish status

export const copyThemeToBuildingSuccess = ({ buildingId, themeId, mode, theme }: { buildingId: string; themeId: string; theme: Theme; mode: string }) => ({
    type: Actions.COPY_THEME_TO_BUILDING_SUCCESS,
    payload: theme,
    meta: { buildingId, themeId, mode }, // Note: themeId is from the source theme, which may be different from the destination theme
});

export const resetThemeStatusRequest = (themeId: string) => ({
    type: Actions.RESET_THEME_STATUS_REQUEST,
    payload: themeId,
});
export const resetThemeStatusSuccess = (theme: Theme) => ({
    type: Actions.RESET_THEME_STATUS_SUCCESS,
    payload: theme,
});
export const resetThemeStatusFailure = (err: Error, themeId: string) => ({
    type: Actions.RESET_THEME_STATUS_FAILURE,
    payload: err,
    error: true,
    meta: { themeId },
});

export const uploadThemeRequest = ({ buildingId, displayName, width, height, file, requirements }: any) => ({
    type: Actions.UPLOAD_THEME_REQUEST,
    payload: { buildingId, displayName, width, height, file, requirements },
});
export const uploadThemeProgress = (progress: number) => ({
    type: Actions.UPLOAD_THEME_PROGRESS,
    payload: progress,
});
export const uploadThemeSuccess = (theme: Theme, buildingId: string) => ({
    type: Actions.UPLOAD_THEME_SUCCESS,
    payload: theme,
    meta: { buildingId },
});
export const uploadThemeFailure = (error: string) => ({
    type: Actions.UPLOAD_THEME_FAILURE,
    payload: error,
    error: true,
});
export const clearUploadTheme = () => ({
    type: Actions.CLEAR_UPLOAD_THEME,
});

export const scheduleThemeSuccess = (schedules: Record<DeviceId, Schedule>, meta: { buildingId: BuildingId; themeId: ThemeId }) => ({
    type: Actions.SCHEDULE_THEME_SUCCESS,
    payload: schedules,
    meta,
});
